import { createContext } from 'react';
import { IUpdateVideoStudio } from 'types';

export type TTypeOfEditVideoStudioModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error';
export interface IInitialFormData {
	name: string;
}

export interface IEditVideoStudioState {
	initialFormData: IInitialFormData | null;
	studioID: string;
	name: string;
	dataForSubmit: IUpdateVideoStudio | null;
	typeOfModalWindow: TTypeOfEditVideoStudioModalWindow;
}

export const editVideoStudioInitialState: IEditVideoStudioState = {
	initialFormData: null,
	studioID: '',
	name: '',
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IEditVideoStudioContext extends IEditVideoStudioState {
	changeName(value: string): void;
	setDataForSubmit(value: IUpdateVideoStudio | null): void;
	changeTypeOfModalWindow(value: TTypeOfEditVideoStudioModalWindow | null): void;
	resetFields(): void;
}

export const EditVideoStudioContext = createContext<IEditVideoStudioContext>({
	changeName: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...editVideoStudioInitialState,
});
